import * as React from "react";

function SvgIkonaVazby(props) {
  return (
    <svg
      data-name="Vrstva 1"
      viewBox="0 0 400 400"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M139.94 317.57a40.79 40.79 0 11-57.68-57.68l99.45-99.45L167.3 146l-99.45 99.48A61.17 61.17 0 00154.36 332l27.23-27.23-14.42-14.42z" />
      <path d="M82.26 139.89a40.79 40.79 0 0157.68-57.68L238.76 181l14.42-14.41-98.82-98.79a61.17 61.17 0 00-86.51 86.51l28.29 28.3 14.42-14.42z" />
      <path d="M332 67.8a61.16 61.16 0 00-86.51 0l-26.55 26.58 14.42 14.42 26.58-26.59a40.79 40.79 0 0157.68 57.68L291 166.48l-.22.21-51.43 51.43-20.75 20.79 14.4 14.42 20.79-20.79 51.43-51.43 26.8-26.8A61.24 61.24 0 00332 67.8z" />
      <path d="M317.62 259.89a40.79 40.79 0 01-57.68 57.68L162 219.62 147.57 234l98 98A61.17 61.17 0 10332 245.48l-27.43-27.43-14.42 14.41z" />
    </svg>
  );
}

export default SvgIkonaVazby;

